<header class="app-header navbar">
  <button class="navbar-toggler d-lg-none" type="button" appMobileSidebarToggler>&#9776;</button>
  <a class="navbar-brand" href="#"></a>
  <button class="navbar-toggler d-md-down-none mr-auto" type="button" appSidebarToggler>&#9776;</button>
  

  <ul class="nav navbar-nav ml-auto">
    
    
    <!--<li class="nav-item dropdown d-md-down-none" dropdown placement="bottom right">
      <a class="nav-link" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false" dropdownToggle (click)="false">
        <i class="icon-bell"></i><span class="badge badge-pill badge-danger">5</span>
      </a>
      <div class="dropdown-menu dropdown-menu-right dropdown-menu-lg" *dropdownMenu aria-labelledby="simple-dropdown">
        <div class="dropdown-header text-center"><strong>You have 5 notifications</strong></div>
        <a href="#" class="dropdown-item">
          <i class="icon-user-follow text-success"></i> New user registered
        </a>
        <a href="#" class="dropdown-item">
          <i class="icon-user-unfollow text-danger"></i> User deleted
        </a>
        <a href="#" class="dropdown-item">
          <i class="icon-chart text-info"></i> Sales report is ready
        </a>
        <a href="#" class="dropdown-item">
          <i class="icon-basket-loaded text-primary"></i> New client
        </a>
        <a href="#" class="dropdown-item">
          <i class="icon-speedometer text-warning"></i> Server overloaded
        </a>
        <div class="dropdown-header text-center"><strong>Server</strong></div>
        <a href="#" class="dropdown-item">
          <div class="text-uppercase mb-1"><small><b>CPU Usage</b></small></div>
          <span class="progress progress-xs">
            <div class="progress-bar bg-info" role="progressbar" style="width: 25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
          </span>
          <small class="text-muted">348 Processes. 1/4 Cores.</small>
        </a>
        <a href="#" class="dropdown-item">
          <div class="text-uppercase mb-1"><small><b>Memory Usage</b></small></div>
          <span class="progress progress-xs">
            <div class="progress-bar bg-warning" role="progressbar" style="width: 70%" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"></div>
          </span>
          <small class="text-muted">11444GB/16384MB</small>
        </a>
        <a href="#" class="dropdown-item">
          <div class="text-uppercase mb-1"><small><b>SSD 1 Usage</b></small></div>
          <span class="progress progress-xs">
            <div class="progress-bar bg-danger" role="progressbar" style="width: 95%" aria-valuenow="95" aria-valuemin="0" aria-valuemax="100"></div>
          </span>
          <small class="text-muted">243GB/256GB</small>
        </a>
      </div>
    </li>
    -->

    
    <!-- FOR EXAMPLE OF NOTIFICATIONS LOOK THE ABOVE COMMENTED CODE -->
    <li class="nav-item dropdown d-md-down-none" dropdown placement="bottom right">
      <a class="nav-link" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false" dropdownToggle (click)="false">
        <i class="icon-bell"></i>
      </a>
      <div class="dropdown-menu dropdown-menu-right dropdown-menu-lg" *dropdownMenu aria-labelledby="simple-dropdown">
        <div class="dropdown-header text-center"><strong>Notificações</strong></div>
        <a href="#" class="dropdown-item">
          <i class="icon-check text-success"></i> Não há novas notificações
        </a>
        
        
      </div>
    </li>

    
    <li class="nav-item d-md-down-none">
      <a class="nav-link" href="#"><i class="icon-location-pin"></i></a>
    </li>
    <li class="nav-item dropdown" dropdown placement="bottom right">
      <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false" dropdownToggle (click)="false">
        <img src="assets/img/avatars/9.jpg" class="img-avatar" alt="admin@demoiselle.org"/>
        <span class="d-md-down-none"><!--User name --></span>
      </a>
      <div class="dropdown-menu dropdown-menu-right" *dropdownMenu aria-labelledby="simple-dropdown">
        <div *ngIf="!isLoggedIn()" class="dropdown-header text-center"><strong>Conta</strong></div>
        <div *ngIf="isLoggedIn()" class="dropdown-header text-center"><strong>{{tokenData.name}}</strong></div>
        <!--
        <a class="dropdown-item" href="#"><i class="fa fa-user"></i> Profile</a>
        <a class="dropdown-item" href="#"><i class="fa fa-wrench"></i> Setting</a>
        -->
        <a *ngIf="isLoggedIn()" class="dropdown-item" (click)="logout()"><i class="fa fa-sign-out"></i> Sair</a>
        <a *ngIf="!isLoggedIn()" class="dropdown-item" href="/#/login"><i class="fa fa-sign-in"></i> Entrar</a>

      </div>
    </li>
    <button class="navbar-toggler d-md-down-none" type="button" appAsideMenuToggler>&#9776;</button>
  </ul>
</header>



// WEBPACK FOOTER //
// /builds/sggd-10899/troca-senha-frontend/frontend/src/app/shared/layout/components/app-header/app-header.component.html